const InfoData = [
  {
    header:
      "Save time, Save Money. It starts with Intelligent Connections & Replacements",
    content:
      "Bearish OS delivers a custom-fit experience. Connect your apps, data, and features for a unified workflow, so you never have to leave Bearish. Replace costly apps with our cost-effective, multifunctional tools. Save big each month while enjoying advanced features like survey forms, calendar scheduling, email analytics, and much more…",
    link: "Learn More about Intelligent Connections",
  },
  {
    header:
      "Send, Track, and Schedule Emails, Messages, Posts, Comments, and Events with Ease",
    content:
      "Harness the revolutionary Bearish OS, powered by BEBA, our Open Source AI. Effortlessly connect events, emails, calls, and social interactions into your CRM. Our rapid, AI-enhanced email and messaging clients offer advanced features, including auto-generated replies, wrapped in a user-friendly interface for streamlined workflow",
    link: "Built in lighting fast clients for everything",
  },
  {
    header: "Plan, Create, Build, and Execute without having to leave Bearish",
    content:
      "Streamline projects with Bearish OS, where video calls, smart transcriptions, and interactive boards come together. Elevate teamwork, customer satisfaction, and project management with ease.",
    link: "Understand the Bearish OS Difference",
  },
  {
    header:
      "From the first ‘Hello’ to the final ‘Sold,’ seamlessly manage every interaction",
    content:
      "Streamline your business with an efficient CRM for customer management, insightful Survey Forms for feedback, and a comprehensive HR solution for a modern workforce",
    link: "Plans from $25/month saving ~$1000/month",
  },
];

export default InfoData;